import { takeEvery, call, put, select } from "redux-saga/effects";
import formActions from "@common/store/form/form.actions";

import api from "../service/habitese.service";
import * as types from './habitese.actionType';
import habiteseSelectors from "./habitese.selectors";
import habiteseActions from "./habitese.actions";
import sessionUtils from '@common/helpers/sessionStorage.utils';

function* workSaga() {
  yield takeEvery(types.GET_IMPRIMIR_HABITESE, getImprimirHabitese);
  yield takeEvery(types.GET_VALIDAR_HABITESE, getValidarHabitese);
  yield takeEvery(types.GET_DADOS_HABITESE, getDadosHabitese);
}

function* getImprimirHabitese() {
  let habitese = yield select(habiteseSelectors.habitese);

  if(!habitese?.NumeroHabitese)
    habitese = sessionUtils.getItem('habitese');

  yield call(api.validaHabitese, habitese);
  const result = yield call(api.imprimirHabitese, habitese);
  const { data } = result;

  if (data) {
    if (data.Success) {
      const destino = "_blank";
      window.open(data.Url, destino);
    }
    else {
      _alert.error(data.Error);
    }
  } else _alert.error('Nenhuma informação retornada para impressão do relatório.');
}

function* getValidarHabitese() {
  const habitese = yield select(habiteseSelectors.habitese);

  if (habitese) {
    yield call(api.validaHabitese, habitese);
    sessionUtils.setItem('habitese', habitese);
    yield put(formActions.redirect("obrasParticulares.visualizarHabitese"));
  }
}

function* getDadosHabitese() {
  const habitese = sessionUtils.getItem('habitese');

  if (habitese) {
    const result = yield call(api.getDadosHabitese, habitese);

    if (result?.data)
      yield put(habiteseActions.setDadosHabitese(result.data));
  }
}

export default workSaga;
